// Клиент саппорт-чата. Реального времени нет намеренно: пока окно открыто,
// клиент дозагружает новые сообщения лёгким GET ?after=<id>; бейдж
// непрочитанных обновляется редким запросом. Доступ проверяет сервер.
import { request } from '../auth/request';
import type { ApiResult } from '../auth/request';

export interface SupportMessage {
  id: number;
  userId: string;
  /** Кто написал: сам пользователь или поддержка ('auto' в adminId — автосообщение). */
  author: 'user' | 'admin';
  adminId: string;
  text: string;
  createdAt: number;
  readAt: number | null;
  /** Сессия завершена: такие сообщения видит только админка (серым). */
  archivedAt: number | null;
  /** Язык интерфейса автора на момент отправки; пусто — неизвестен. */
  lang: string;
  /** Вложение; сам файл отдаёт GET /api/support/files/<id сообщения>. */
  file: { name: string; mime: string; size: number } | null;
}

/** Вложение на отправку: файл уезжает data URL-ом внутри JSON. */
export interface SupportFileInput {
  name: string;
  dataUrl: string;
}

/** Пределы вложений — те же, что проверяет сервер. */
export const MAX_SUPPORT_FILE_BYTES = 3 * 1024 * 1024;
export const SUPPORT_FILE_ACCEPT = 'image/png,image/jpeg,image/webp,application/pdf';

/** Сервер обрезает длиннее — предупреждаем на вводе тем же числом. */
export const MAX_SUPPORT_TEXT = 2000;

export function fetchSupportMessages(
  afterId = 0,
  signal?: AbortSignal,
): Promise<
  ApiResult<{ messages: SupportMessage[]; closedAt: number | null; filesAllowed: boolean }>
> {
  const query = afterId > 0 ? `?after=${afterId}` : '';
  return request(`/api/support/messages${query}`, { method: 'GET', signal });
}

export function sendSupportMessage(
  text: string,
  lang: string,
  file?: SupportFileInput,
): Promise<ApiResult<{ message: SupportMessage }>> {
  return request('/api/support/messages', {
    method: 'POST',
    json: { text, lang, ...(file ? { file } : {}) },
  });
}

export function fetchSupportUnread(signal?: AbortSignal): Promise<ApiResult<{ unread: number }>> {
  return request('/api/support/unread', { method: 'GET', signal });
}
